import React from "react";
import bannerimg from "../../assets/images/DoctorBanner.jpg";
import bannerimg_M from "../../assets/images/Doctors page  headers Mobilescreen-02.jpg";
const DoctorsBanner = () => {
  return (
 <div className=" w-full xl:bg-fixed relative mx-auto  overflow-hidden flex items-center justify-center">
      {/* Content */}
      <div className="w-full">
        <img src={bannerimg} alt="" className="w-full  h-auto hidden xl:block " />
        <img src={bannerimg_M} alt="" className="w-full  h-auto  block xl:hidden" />
      </div>
    </div>
  );
};
export default DoctorsBanner;


